/**
 * ISO 639-1 / BCP-47 primary tags aligned with X `tweet.lang` for Home filter + create form.
 * (Same codes the language filter uses once they appear in `tweet_data`.)
 */
const CODES = [
  'am', 'ar', 'as', 'bg', 'bn', 'bo', 'bho', 'ca', 'cs', 'cy', 'da', 'de', 'dz', 'el', 'en', 'es', 'et', 'eu', 'fa', 'fi', 'fr', 'ga', 'gl', 'gu', 'he', 'hi', 'hr', 'hu', 'id', 'is', 'it', 'ja', 'km', 'kn', 'ko', 'lo', 'lt', 'lv', 'mai', 'mr', 'ms', 'my', 'ne', 'nl', 'no', 'or', 'pa', 'pl', 'ps', 'pt', 'ro', 'ru', 'sa', 'sd', 'si', 'sk', 'sl', 'sq', 'sr', 'sv', 'ta', 'te', 'th', 'tl', 'tr', 'ug', 'uk', 'ur', 'vi', 'zh',
];
export const MARKET_LANGUAGE_OPTIONS: readonly string[] = [...CODES].sort((a, b) => a.localeCompare(b));
